module.exports = __webpack_public_path__ + "static/media/BAP10.b9df8cbe.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP10.png
 ** module id = 676
 ** module chunks = 0
 **/